import PageLayout from "../../layouts/pagelayout/PageLayout";
import PartnerForm from "./partnerForm.jsx/PartnerForm";
import PartnerLanding from "./partnerLanding/PartnerLanding";

const PartnerWithUs = () => {
  return (
    <PageLayout>
      <PartnerLanding />
      <PartnerForm />
    </PageLayout>
  );
};
export default PartnerWithUs;
